export const ChargePermissionEnum = {
  Y: 'Y',
  N: 'N',
  M: 'M',
  K: 'K',
  B: 'B',
};

export const ChargePermissionOptions = [
  { text: 'Y - Allow Charges', value: ChargePermissionEnum.Y, key: 1 },
  { text: 'N - No Charges', value: ChargePermissionEnum.N, key: 2 },
  { text: 'M - Meals Only', value: ChargePermissionEnum.M, key: 3 },
  { text: 'K - Milk Only', value: ChargePermissionEnum.K, key: 4 },
  { text: 'B - Meals & Milk Only', value: ChargePermissionEnum.B, key: 5 },
];



// WEBPACK FOOTER //
// ./src/common/Constants/ChargePermissions.js